var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("rect", { stroke: "currentColor", strokeWidth: 2, fill: "#FFF", x: 5, y: 5, width: 38, height: 38, rx: 6 }),
            React.createElement("rect", { fill: "#FF2A2A", transform: "rotate(-45 24 24)", x: 23, y: 4, width: 2, height: 40, rx: 1 }))));
});
